const fechaTurnoFormat2 = () => {
    let fechaDefault = new Date();
  
    return (
      fechaDefault.getFullYear() +
      "-" +
      (fechaDefault.getMonth() + 1 < 10
        ? "0" + (fechaDefault.getMonth() + 1)
        : fechaDefault.getMonth() + 1) +
      "-" +
      (fechaDefault.getDate() < 10
        ? "0" + fechaDefault.getDate()
        : fechaDefault.getDate()) + "T00:00:00"
    );
  };
  export default fechaTurnoFormat2;